import React from "react";
import { Link } from "react-router-dom";
import { Users, Maximize, BedDouble } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import { PhotosPending } from "./PhotosPending";
import { mediaUrl } from "../lib/api";

export default function AccommodationCard({ item, onBook, dateQuery = "" }) {
  const { t } = useI18n();
  const catLabel = item.type === "gite" ? t("common.gite") : t("common.chambre");
  const detailTo = `/hebergement/${item.slug}${dateQuery}`;

  return (
    <article
      className="group bg-white rounded-2xl overflow-hidden border border-black/5 shadow-[0_8px_32px_rgba(44,48,48,0.06)] hover:shadow-[0_16px_48px_rgba(44,48,48,0.12)] transition-shadow flex flex-col h-full"
      data-testid={`accommodation-card-${item.slug}`}
    >
      <Link to={detailTo} className="block relative aspect-[4/3] overflow-hidden">
        {item.photos_pending ? (
          <PhotosPending className="w-full h-full" compact />
        ) : (
          <img src={mediaUrl(item.main_image)} alt={item.name} loading="lazy" className="img-zoom w-full h-full object-cover" />
        )}
        <span className="absolute top-3 left-3 rounded-full bg-white/90 backdrop-blur px-3 py-1 text-xs font-medium text-brand">{catLabel}</span>
      </Link>
      <div className="p-6 flex flex-col flex-1">
        <h3 className="font-heading text-2xl text-ink-900 mb-3">{item.name}</h3>
        <div className="flex flex-wrap gap-x-4 gap-y-1.5 text-sm text-ink-600 mb-4">
          {item.capacity ? <span className="inline-flex items-center gap-1.5"><Users size={16} strokeWidth={1.5} className="text-brand" />{item.capacity} {t("common.people")}</span> : null}
          {item.surface ? <span className="inline-flex items-center gap-1.5"><Maximize size={16} strokeWidth={1.5} className="text-brand" />{item.surface} m²</span> : null}
          {item.beds ? <span className="inline-flex items-center gap-1.5"><BedDouble size={16} strokeWidth={1.5} className="text-brand" />{item.beds}</span> : null}
        </div>
        {Array.isArray(item.amenities) && item.amenities.length > 0 && (
          <div className="flex flex-wrap gap-1.5 mb-5">
            {item.amenities.slice(0, 4).map((a) => (
              <span key={a} className="rounded-full bg-cream px-2.5 py-1 text-[11px] text-ink-600 border border-black/5">{a}</span>
            ))}
          </div>
        )}
        <div className="mt-auto">
          {item.price_from ? (
            <p className="text-sm text-ink-400 mb-3">{t("common.from")} <span className="text-ink-900 font-semibold text-lg">{item.price_from} €</span> {t("common.perNight")}</p>
          ) : null}
          <div className="flex gap-2">
            <Link
              to={detailTo}
              data-testid={`view-accommodation-${item.slug}`}
              className="flex-1 text-center rounded-full border border-brand text-brand px-4 py-2.5 text-sm font-medium hover:bg-brand-50 transition-colors"
            >
              {t("common.seeAccommodation")}
            </Link>
            <button
              onClick={() => onBook ? onBook(item) : null}
              data-testid={`book-accommodation-${item.slug}`}
              className="flex-1 rounded-full bg-brand text-white px-4 py-2.5 text-sm font-medium hover:bg-brand-600 transition-colors"
            >
              {t("common.book")}
            </button>
          </div>
        </div>
      </div>
    </article>
  );
}
